// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2wLWC","savePackageButton":"ClientWallet_savePackageButton__3I302"};